import Data from './data';
import Results from './results';

export default class Word {
  constructor() {
    this.wordsContainer = document.querySelector('.word-items');
    this.container = Word.createNode(this.container, 'div', 'word-wrapper');
    this.word = Word.createNode(this.word, 'p', 'word');
    this.transcription = Word.createNode(this.transcription, 'p', 'transcription');
    this.image = Word.createNode(this.image, 'img', 'image');
    this.innerWord = Word.createNode(this.innerWord, 'div', 'inner-wrapper');
    this.resultsCards = [];
    this.translations = null;
    this.resultObject = null;
  }

  static createNode(elem, node, classes) {
    let el = elem;
    el = document.createElement(`${node}`);
    el.className = `${classes}`;
  }

  static getRandom(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  async renderWord(level) {
    const random = Word.getRandom(0, 29);
    const data = new Data(random, level);
    await data.getData();
    const words = data.data;
    for (let i = 0; i < words.length - 10; i += 1) {
      const wordContainer = document.createElement('div');
      wordContainer.classList.add('word-wrapper');
      wordContainer.setAttribute('data-image', `${words[i].image}`);
      wordContainer.setAttribute('data-audio', `${words[i].audio}`);
      this.resultsCards.push(words[i]);
      this.resultsCards[i].translation = data.getTranslation(this.resultsCards[i].word);
      const p = document.createElement('p');
      p.innerText = `${words[i].word}`;
      p.classList.add('word-eng');
      const transkr = document.createElement('p');
      transkr.classList.add('word-transkr');
      transkr.innerText = `${words[i].transcription}`;
      wordContainer.append(p, transkr);
      this.wordsContainer.append(wordContainer);
    }
    const transl = await Promise.all(this.resultsCards.map((el) => el.translation));
    this.translations = transl;
    this.getResultObject();
    const result = new Results(this.resultsCards);
    result.renderResults();
  }

  getResultObject() {
    for (let i = 0; i < this.resultsCards.length; i += 1) {
      this.resultsCards[i].translation = this.translations[i];
    }
  }

  static async renderWordEng() {
    const data = new Data(0, 1);
    await data.getData();
    const words = data.data;
    for (let i = 0; i < words.length; i += 1) {
      const p = document.createElement('p');
      p.innerText = `${words[i].word}`;
      document.body.append(p);
    }
  }

  static async getData() {
    const data = new Data(0, 1);
    this.data = await data.data;
    return this.data;
  }
}
